<template>
  <div class="form-single-fragment" style="position: relative;">
<!--    <el-form ref="areaWorkFormFilter" :model="areaWorkForm" :size="defaultFormItemSize"-->
<!--      label-width="100px" label-position="right" @submit.native.prevent-->
<!--    >-->
<!--      <filter-box :item-width="350"-->
<!--        @search="refreshAreaWorkForm(true)"-->
<!--        @reset="onResetareaWorkForm"-->
<!--      >-->
<!--      </filter-box>-->
<!--    </el-form>-->
    <el-form ref="areaWorkForm" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="活动内容(100字以上)" prop="AreaWork.workContent">
            <el-input class="input-item" v-model="formData.AreaWork.workContent"
              type="textarea" :rows="2"
              :clearable="true" placeholder="活动内容(100字以上)"  minlength="100" show-word-limit
            />
          </el-form-item>
        </el-col>
<!--        <el-col :span="12">-->
<!--          <el-form-item label="现场图片" prop="AreaWork.siteImages">-->
<!--            <el-upload-->
<!--              class="upload-image-item" name="uploadFile" :headers="getUploadHeaders"-->
<!--              :action="getUploadActionUrl('/admin/app/areaWork/upload')"-->
<!--              :data="{fieldName: 'siteImages', asImage: true}"-->
<!--              :on-success="onSiteImagesUploadSuccess"-->
<!--              :on-remove="onSiteImagesRemoveFile"-->
<!--              :before-upload="pictureFile"-->
<!--              :on-error="onUploadError"-->

<!--              :show-file-list="false">-->
<!--              <div v-if="areaWorkForm.siteImages.impl.fileList && areaWorkForm.siteImages.impl.fileList[0] != null" style="position: relative">-->
<!--                <img class="upload-image-show"-->
<!--                  :src="areaWorkForm.siteImages.impl.fileList[0].url" />-->
<!--                <div class="upload-img-del el-icon-close"-->
<!--                  @click.stop="onSiteImagesRemoveFile(null, null)" />-->
<!--              </div>-->
<!--              <i v-else class="el-icon-plus upload-image-item"></i>-->
<!--            </el-upload>-->
<!--          </el-form-item>-->
<!--        </el-col>-->

        <el-col :span="12">
          <el-form-item label="现场图片" prop="AreaWork.siteImages">
            <el-upload
              class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
              :action="getUploadActionUrl('/admin/app/areaWork/upload')"
              :data="{fieldName: 'siteImages', asImage: true}"
              :on-success="onSiteImagesUploadSuccess"
              :on-remove="onSiteImagesRemoveFile"
              :on-error="onUploadError"
              :show-file-list="true"
              :on-preview="handlePreview"
              :limit="areaWorkForm.siteImages.impl.maxCount"
              :on-exceed="onUploadLimit"
              :file-list="areaWorkForm.siteImages.impl.fileList"
              list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>

        <!--        <el-col :span="24">-->
<!--          <el-form-item label="附件" prop="AreaWork.attachedFiles">-->
<!--            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple-->
<!--              :action="getUploadActionUrl('/admin/app/areaWork/upload')"-->
<!--              :data="{fieldName: 'attachedFiles', asImage: false}"-->
<!--              :on-success="onAttachedFilesUploadSuccess"-->
<!--              :on-remove="onAttachedFilesRemoveFile"-->
<!--              :on-error="onUploadError" :on-exceed="onUploadLimit"-->
<!--              :limit="areaWorkForm.attachedFiles.impl.maxCount"-->
<!--              :file-list="areaWorkForm.attachedFiles.impl.fileList"-->
<!--              :show-file-list="true">-->
<!--              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>-->
<!--            </el-upload>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="12" v-show="true">
          <el-form-item label="附件" prop="Specialist.attachedFiles">
            <el-upload  name="uploadFile" :headers="getUploadHeaders" multiple
                       :action="getUploadActionUrl('/admin/app/areaWork/upload')"
                       :data="{fieldName: 'attachedFiles', asImage: false}"
                       :on-success="onAttachedFilesUploadSuccess"
                       :on-remove="onAttachedFilesRemoveFile"
                       :on-error="onUploadError" :on-exceed="onUploadLimit"
                       :limit="areaWorkForm.attachedFiles.impl.maxCount"
                       :file-list="areaWorkForm.attachedFiles.impl.fileList"
                       :show-file-list="false">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
            <div v-if="areaWorkForm.attachedFiles.impl.fileList && areaWorkForm.attachedFiles.impl.fileList[0] != null" style="position: relative">
              <div v-for="(item,index) in areaWorkForm.attachedFiles.impl.fileList" :key="item.url"
                   style="display:flex;margin-top: 5px;">
                <div> {{item.name}}</div>
                <div style="margin-left: 15px;display: inline-flex">

                  <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                  <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                  <el-button type="primary"
                             @click="deleteAttachedFiles(item,areaWorkForm.attachedFiles.impl.fileList,index)">删除
                  </el-button>
                </div>

              </div>
            </div>
            <template v-else>
              <a v-for="item in areaWorkForm.attachedFiles.impl.fileList" :key="item.url"
                 href="javascript:void(0);" @click="previewFile(item.url, item.filename)">
                {{item.name}}
              </a>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize"
                       @click="onAddClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { AreaWorkController, DictionaryController } from '@/api';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  name: 'areaWorkForm',
  props: {
    id: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      formData: {
        AreaWork: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          workContent: undefined,
          siteImages: undefined,
          attachedFiles: undefined,
          areaId: undefined,
          mediaAdoption: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'AreaWork.workContent': [
          {required: true, message: '请输入活动内容', trigger: 'blur'}
        ],
        'AreaWork.siteImages': [
          {required: true, message: '请输入现场图片', trigger: 'blur'}
        ]
      },
      areaWorkForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        siteImages: {
          impl: new UploadWidget(1)
        },
        attachedFiles: {
          impl: new UploadWidget(1)
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    /**
     * 更新辖区工作表单
     */
    refreshAreaWorkForm (reloadData = false) {
      this.loadAreaWorkData().then(res => {
        if (!this.areaWorkForm.isInit) {
        // 初始化下拉数据
        }
        this.areaWorkForm.isInit = true;
      }).catch(e => {});
    },
    loadAreaWorkData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.AreaWork.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          AreaWorkController.view(this, params).then(res => {
            this.formData.AreaWork = {...res.data, isDatasourceInit: true};
            let attachedFilesDownloadParams = {
              id: this.formData.AreaWork.id,
              fieldName: 'attachedFiles',
              asImage: false
            }
            this.areaWorkForm.attachedFiles.impl.fileList = this.parseUploadData(this.formData.AreaWork.attachedFiles, attachedFilesDownloadParams);
            let siteImagesDownloadParams = {
              id: this.formData.AreaWork.id,
              fieldName: 'siteImages',
              asImage: true
            }
            this.areaWorkForm.siteImages.impl.fileList = this.parseUploadData(this.formData.AreaWork.siteImages, siteImagesDownloadParams);
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.AreaWork.isDatasourceInit = true;
          resolve();
        }
      });
    },
    /**
     * 保存
     */
    onAddClick () {
      this.$refs.areaWorkForm.validate((valid) => {
        if (!valid) return;
        let workContent = this.formData.AreaWork.workContent
        if (workContent.length < 100) {
          this.$message.error('活动内容100字以上')
          return
        }
        let params = {
          areaWorkDto: {
            // workContent: this.formData.AreaWork.workContent,
            // siteImages: this.formData.AreaWork.siteImages,
            // attachedFiles: this.formData.AreaWork.attachedFiles
            ...this.formData.AreaWork
          }
        };
        if (params.areaWorkDto.id) {
          AreaWorkController.update(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        } else {
          AreaWorkController.add(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        }
      });
    },
    onResume () {
      this.refreshAreaWorkForm(true);
    },
    initFormData () {
    },
    /**
     * 现场图片上传成功
     */
    onSiteImagesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.areaWorkForm.siteImages.impl.onFileChange(file, fileList);
        this.formData.AreaWork.siteImages = this.fileListToJson(this.areaWorkForm.siteImages.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除现场图片
     */
    onSiteImagesRemoveFile (file, fileList) {
      this.areaWorkForm.siteImages.impl.onFileChange(file, fileList);
      this.formData.AreaWork.siteImages = this.fileListToJson(this.areaWorkForm.siteImages.impl.fileList);
    },
    /**
     * 附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.areaWorkForm.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.AreaWork.attachedFiles = this.fileListToJson(this.areaWorkForm.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除附件
     */
    deleteAttachedFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile(file, fileList)
    },
    onAttachedFilesRemoveFile (file, fileList) {
      this.areaWorkForm.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.AreaWork.attachedFiles = this.fileListToJson(this.areaWorkForm.attachedFiles.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        AreaWork: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          workContent: undefined,
          siteImages: undefined,
          attachedFiles: undefined,
          areaId: undefined,
          mediaAdoption: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshAreaWorkForm();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
